// extracted by mini-css-extract-plugin
export default {"container":"MemberSelect_container_fb664","label":"MemberSelect_label_b5ce4"};